import { Input as AntdInput, InputProps as AntdInputProps } from 'antd'

export interface InputProps extends AntdInputProps {}

const Input: React.FC<InputProps> = (props) => {
  return <AntdInput size='middle'  className='shadow' {...props} />
}

export default Input
